import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=7f42a8f3&scoped=true&"
import script from "./Reviews.vue?vue&type=script&lang=ts&"
export * from "./Reviews.vue?vue&type=script&lang=ts&"
import style0 from "./Reviews.vue?vue&type=style&index=0&id=7f42a8f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42a8f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7f42a8f3', component.options)
    } else {
      api.reload('7f42a8f3', component.options)
    }
    module.hot.accept("./Reviews.vue?vue&type=template&id=7f42a8f3&scoped=true&", function () {
      api.rerender('7f42a8f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/Reviews.vue"
export default component.exports